import script from "./Registration.vue?vue&type=script&setup=true&lang=ts"
export * from "./Registration.vue?vue&type=script&setup=true&lang=ts"

import "./Registration.vue?vue&type=style&index=0&id=703e00e6&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703e00e6"]])

export default __exports__